function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.48 26.472V25.128C12.6987 25.128 13.808 24.232 13.808 22.44V7.976C13.808 7.336 13.3707 7.016 12.496 7.016C11.8347 7.016 11.2587 7.13333 10.768 7.368C10.2987 7.58133 9.88267 7.912 9.52 8.36C9.17867 8.808 8.88 9.37333 8.624 10.056C8.38933 10.7173 8.176 11.496 7.984 12.392L6 12.104L6.896 5C7.45067 5.08533 8.05867 5.14933 8.72 5.192C9.38133 5.23467 9.904 5.256 10.288 5.256H22.928C23.3973 5.256 23.9733 5.23467 24.656 5.192C25.3387 5.14933 25.9573 5.08533 26.512 5V12.008L24.656 12.168C24.5493 10.4827 24.1867 9.224 23.568 8.392C22.9707 7.56 21.9253 7.144 20.432 7.144C19.5147 7.144 19.056 7.42133 19.056 7.976V22.44C19.056 24.232 20.1867 25.128 22.448 25.128V26.472H10.48Z",
  fill: "#D5D7DE"
});

var SvgText = function SvgText(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgText, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/text.a936f3bc.svg";
export { ForwardRef as ReactComponent };